function useStyles({ changeColor, value }: { changeColor: boolean; value: boolean }) {
    return {
        container: () => {
            return {
                width: 'max-content',
                borderRadius: '40px',
                padding: '2px',
                backgroundColor: 'blue.main',
                '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                    borderRadius: '40px !important',
                    borderColor: 'transparent',
                },
                '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                    borderRadius: '40px !important',
                    borderColor: 'transparent',
                },
                ...(changeColor && value) && {
                    backgroundColor: 'c_green.main',
                }
            }
        },
        toggle: ({widthVariable, width}:{widthVariable:boolean, width:number}) => ({
            color: 'white',
            padding: '4px 8px',
            borderRadius: '40px',
            fontSize: '12px',
            fontWeight: 'bold',
            ...(widthVariable ? { width: `${width}px` } : {}),
            '&.Mui-selected': {
                '&:hover': {
                    background: 'white',
                    color: 'c_grey.200'
                },
                background: 'white',
                color: 'c_grey.200',
                '&.Mui-disabled': {
                    background: 'white',
                    color: 'c_grey.main',
                }
            },
        })
    }
}

export { useStyles }